(function ($) {

    /**
     * Tests if a node is positioned within the current viewport.
     * It does not test any other type of "visibility", like css display,
     * opacity, presence in the dom, etc - it only considers position.
     *
     * By default, it tests if at least 1 pixel is showing, regardless of
     * orientation - however an optional argument is accepted, a callback
     * that is passed the number of pixels distant between each edge of the
     * node and the corresponding viewport.  If the callback argument is provided
     * the return value (true of false) of that callback is used instead.
     */
    $.fn.isOnScreen = function(x_offset, y_offset, partial, currentVisible) {
        if(x_offset == null || typeof x_offset == 'undefined') x_offset = 1;
        if(y_offset == null || typeof y_offset == 'undefined') y_offset = 1;
        if(partial == null || partial == 'undefined') partial = false;
        if(currentVisible == null || currentVisible == 'undefined') currentVisible = false;

        var win = $(window),
            viewport = {
                top : win.scrollTop(),
                left : win.scrollLeft()
            },
            height = this.outerHeight(),
            width = this.outerWidth(),
            bounds = this.offset(),
            visible,
            deltas;

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        if (currentVisible) {
            viewport.right = viewport.left + win.innerWidth();
            viewport.bottom = viewport.top + win.outerHeight();
        }

        if(!width || !height) return false;

        bounds.right = bounds.left + width;
        bounds.bottom = bounds.top + height;

        visible = (
            !(viewport.right < bounds.left ||
                viewport.left > bounds.right ||
                viewport.bottom < bounds.top ||
                viewport.top > bounds.bottom)
        );

        

        if(!visible) return false;

        if(partial){
            deltas = {
                top : viewport.bottom - bounds.top,
                left: viewport.right - bounds.left,
                bottom: bounds.bottom - viewport.top,
                right: bounds.right - viewport.left
            };

            
            let result = deltas.top > 0 && deltas.left > 0 && deltas.right > 0 && deltas.bottom > 0
            return result;

        }else{
            deltas = {
                top:    Math.min(1, (bounds.bottom - viewport.top) / height),
                bottom: Math.min(1, (viewport.bottom - bounds.top) / height),
                left:   Math.min(1, (bounds.right - viewport.left) / width),
                right:  Math.min(1, (viewport.right - bounds.left) / width)
            };

            let result = (deltas.left * deltas.right) >= x_offset && (deltas.top * deltas.bottom) >= y_offset;
            return result;
        }
    }
})(jQuery);



    
